import { Navigate, Outlet } from 'react-router'
import { useAuth } from '@/features/auth'
import { useLangParam } from '@/shared/hooks'
import { Loader2 } from 'lucide-react'

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()
  const { lang } = useLangParam()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    )
  }

  if (!isAuthenticated) {
    // Redirect to localized landing page
    return <Navigate to={`/${lang}`} replace />
  }

  return <Outlet />
}
